//以成员函数形式设置插件
(function ($) {
    $.fn.extend({
        page: function (options) {
            let defaultOptions = {
                current: 1,
                otherCss: "",
                total: 0,
                totalSize: 0,
                pageSize: 5,
                showTotal: false,
                footCallback: function (page) {

                },
                pageCallback: function (page) {
                },
                pageSizeCallback: function (pageSize) {

                }
            }
            let option = $.extend(defaultOptions, options);
            let dom = "<div class='topage'><select id='page-select'><option value='5'>5</option><option value='10'>10</option><option value='15'>15</option><option value='20'>20</option></select></div>";
            if (option.showTotal) {
                dom += "<p>Total:" + option.totalSize + "</p>";
            }
            dom += "<div id='page-lift'>"
            if (option.current === 1) {
                dom += "<a href='javascript:void(0);' class='page-foot page-prev disabled'><i class='fa fa-angle-left'></i></a>";
            } else {
                dom += "<a href='javascript:void(0);' class='page-foot page-prev'><i class='fa fa-angle-left'></i></a>";
            }

            dom += "<ul class='page-select'>";
            for (let i = 0; i < option.total; i++) {
                if (option.current - 1 === i) {
                    dom += "<li class='current'>"
                } else {
                    dom += "<li>"
                }
                dom += (i + 1) + "</li>";
            }
            dom += "</ul><span class='page-view'><span class='current'>" + option.current + "</span><span>/" + option.total + "</span></span>";
            if (option.current === option.total) {
                dom += "<a href='javascript:void(0);' class='page-foot page-next disabled'><i class='fa fa-angle-right'></i></a>";
            } else {
                dom += "<a href='javascript:void(0);' class='page-foot page-next'><i class='fa fa-angle-right'></i></a>";
            }

            dom += "</div>";
            if (option.otherCss) {
                this.addClass(option.otherCss);
            }
            $(this).html(dom);
            $("#page-select").val(option.pageSize);
            $(".page-prev").on("click", function () {
                if (option.current > 1) {
                    option.footCallback(-1);
                }

            });
            $(".page-next").on("click", function () {
                if (option.current < option.total) {
                    option.footCallback(1);
                }
            });
            $(".page-view").on("click", function () {
                $(".page-select").toggle();
            });

            $(".page-select").on("click", "li", function (e) {
                let selected = parseInt($(e.currentTarget).text());
                if (selected !== option.current) {
                    option.pageCallback(parseInt($(e.currentTarget).text()));
                }
                $(".page-select").hide();
            });
            $("#page-select").on("change", function (e) {
                option.pageSizeCallback($(this).val());
            })
            return this;    //为了支持链式操作 要返回当前对象
        }
    })
})(jQuery);